import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { useMemo } from 'react';
import DIcon from '../DIcon';
export default function DBadge({ text, soft = false, color = 'primary', id, rounded, className, size, style, iconStart, iconEnd, iconMaterialStyle, iconFamilyClass, iconFamilyPrefix, dataAttributes, }) {
    const generateClasses = useMemo(() => ({
        badge: true,
        [`badge-${color}`]: !!color && !soft,
        [`badge-soft-${color}`]: !!color && soft,
        'rounded-pill': !!rounded,
        [`badge-${size}`]: !!size,
    }), [rounded, soft, color, size]);
    return (_jsxs("span", Object.assign({ className: classNames(generateClasses, className), style: style }, id && { id }, dataAttributes, { children: [iconStart && (_jsx(DIcon, { icon: iconStart, familyClass: iconFamilyClass, familyPrefix: iconFamilyPrefix, materialStyle: iconMaterialStyle })), _jsx("span", { children: text }), iconEnd && (_jsx(DIcon, { icon: iconEnd, familyClass: iconFamilyClass, familyPrefix: iconFamilyPrefix, materialStyle: iconMaterialStyle }))] })));
}
//# sourceMappingURL=DBadge.js.map